import React, { useEffect, useState } from 'react'
import Master from '../partials/master'
import { useUser } from '../UserContext';
import Loader from '../Loader';
import BannerSection from '../BannerSection';

const Account = () => {
    const user = useUser()
    const [billingData, setBillingData] = useState(null); // state variable
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");
    const [isOpen, setIsOpen] = useState(false); //for billing address modal

    const [loading, setLoading] = useState(true);

    const [visibleCount, setVisibleCount] = useState(10); // how many to show initially
    const [failedVisibleContent, setFailedVisibleCount] = useState(10); // how many to show initially



    const handleViewMore = () => {
        setVisibleCount((prev) => prev + 10);
    };

    const handleFailedPagination = () => {
        setFailedVisibleCount((prev) => prev + 10);
    }
    const handleLessfailedPagination = () => {
        setFailedVisibleCount(10);
    }

    const handleViewLess = () => {
        setVisibleCount(10);
    };

    const facilityId = user?.user?.facility?.id
    const fetchBillingData = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/facility/${facilityId}/billing-portal/`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch billing portal data");
            }

            const data = await response.json();
            setBillingData(data); // ✅ save API data in state variable
        } catch (error) {
            console.error("Error fetching billing portal:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (facilityId) {
            fetchBillingData();
        }
    }, [facilityId]);


    const allInvoices = billingData?.flatMap((sub) =>
        sub.paid_invoices.map((invoice) => ({
            ...invoice,
            plan_name: sub.plan_name,
            module: sub.module,
            amount: sub.amount,
            currency: sub.currency,
        }))
    );
    const failedInvoices = billingData?.flatMap((sub) =>
        sub.failed_invoices.map((invoice) => ({
            ...invoice,
            plan_name: sub.plan_name,
            module: sub.module,
            amount: sub.amount,
            currency: sub.currency,
        }))
    );

    const card = billingData?.[0]?.payment_method;

    const getCardIconClass = (brand) => {
        switch (brand?.toLowerCase()) {
            case 'visa':
                return 'fa-brands fa-cc-visa';
            case 'mastercard':
                return 'fa-brands fa-cc-mastercard';
            case 'american express':
                return 'fa-brands fa-cc-amex';
            case 'discover':
                return 'fa-brands fa-cc-discover';
            default:
                return 'fa-solid fa-credit-card'; // fallback
        }
    };

    const getStatusDetails = (status) => {
        switch (status) {
            case 'active':
                return {
                    label: 'Active',
                    className: 'bg-green-100 text-green-800  rounded-full font-semibold'
                };
            case 'trialing':
                return {
                    label: 'Trial Period',
                    className: 'bg-blue-100 text-blue-800  rounded-full font-semibold'
                };
            case 'canceled':
                return {
                    label: 'Cancelled',
                    className: 'bg-red-100 text-red-800  rounded-full font-semibold'
                };
            case 'pending_cancel':
                return {
                    label: 'Pending Cancellation',
                    className: 'bg-yellow-100 text-yellow-800  rounded-full font-semibold'
                };
            case 'past_due':
                return {
                    label: 'Past Due',
                    className: 'bg-orange-100 text-orange-800  rounded-full font-semibold'
                };
            default:
                return {
                    label: '',
                    className: ''
                };
        }
    };
    const info = billingData?.[0]?.billing_information;

    // const handleAddressVisibility = !!(
    //     info?.name?.trim() &&
    //     info?.phone?.trim() &&
    //     info?.email?.trim() &&
    //     info?.address?.trim()
    // );

    const [formData, setFormData] = useState({
        name: info?.name,
        email: info?.email,
        phone: info?.phone,
        address: info?.address,
    });

    const handleUpdateInfo = () => {
        setIsOpen(true)
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form submitted:", formData);
        setIsOpen(false);
    };
    return (
        <Master>
            {loading && (
                <div className="overlay">
                    <div className="loader-wrapper">
                        <Loader height={120} width={120} />
                    </div>
                </div>
            )}
            <div>
                <BannerSection />
                <div className=" grid grid-cols-12 rounded-lg shadow items-stretch mt-4">

                    {/* <div className='lg:col-span-12 md:col-span-12 col-span-12 px-4 pt-4'>
                        {handleAddressVisibility && (
                            <section className="rounded-xl border bg-white p-6 shadow-sm">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-3xl font-semibold mt-0">Billing Information</h2>
                                    <button className="inline-flex items-center gap-2 text-2xl text-sky-700 hover:underline" onClick={handleUpdateInfo}>
                                        <i className="fa-solid fa-pen"></i>
                                        Update information
                                    </button>
                                </div>
                            </section>
                        )}
                    </div> */}
                    {billingData && billingData?.filter((item) => item?.plan_name === "Staff Plus" || item?.module === "staff")?.map((item, index) => (
                        <div className='lg:col-span-4 md:col-span-6 col-span-12 p-4 md:p-10'>
                            <section className="rounded-xl border bg-white p-6 h-full" key={index}>
                                <div className="flex items-start justify-between gap-4">
                                    <div>
                                        <div className={`flex items-center px-4 py-2 rounded-full text-2xl font-medium ${getStatusDetails(
                                            item?.status
                                        ).className}`}>
                                            {getStatusDetails(item?.status).label}
                                        </div>
                                        <h1 className="mt-3 text-2xl font-bold">{item?.module ? item?.module : item?.plan_name} <span>{item?.interval === 'month' ? "(monthly)" : item?.interval}</span></h1>
                                        <p className="text-2xl text-muted-foreground">${item?.amount} per {item?.interval}</p>
                                    </div>
                                    <a href={item?.manage_subscription_url} className='hover:!text-white text-white'>
                                        <button className="rounded-lg px-4 text-white  bg-indigo-500 hover:opacity-90 py-2 ">Manage Subscription</button>
                                    </a>
                                </div>
                                {item?.last_payment_error && (
                                    <div className="mt-3 flex items-center gap-2 text-2xl  text-rose-600">
                                        <i className="fa-regular fa-credit-card"></i>
                                        <span>{item?.last_payment_error}.</span>
                                    </div>
                                )}
                            </section>
                        </div>
                    ))}
                    {billingData && billingData?.filter((item) => item?.plan_name === "Up to 15 Beds" || item?.module === "resident")?.map((item, index) => (
                        <div className='lg:col-span-4 md:col-span-6 col-span-12 p-4 md:p-10'>
                            <section className="rounded-xl border bg-white p-6 h-full" key={index}>
                                <div className="flex items-start justify-between gap-4">
                                    <div>
                                        <div className={`px-4 py-2 rounded-full text-2xl font-medium ${getStatusDetails(
                                            item?.status
                                        ).className}`}>
                                            {getStatusDetails(item?.status).label}
                                        </div>
                                        <h1 className="mt-3 text-2xl font-bold">{item?.module ? item?.module : item?.plan_name} <span>{item?.interval === 'month' ? "(monthly)" : item?.interval}</span></h1>
                                        <p className="text-2xl text-muted-foreground">${item?.amount} per {item?.interval}</p>
                                    </div>
                                    <a href={item?.payment_method_link} className='hover:!text-white text-white'>
                                        <button className="rounded-lg px-4 text-white bg-indigo-500 hover:opacity-90 py-2">Manage Subscription</button>
                                    </a>
                                </div>
                                <div className="mt-3 flex items-center gap-2 text-2xl  text-rose-600">
                                    <i className="fa-regular fa-credit-card"></i>
                                    <span>{item?.last_payment_error}.</span>
                                </div>
                            </section>
                        </div>
                    ))}
                    <div className='lg:col-span-4 md:col-span-6 col-span-12 p-4 md:p-10'>
                        <section className="rounded-xl border bg-white p-6 shadow-sm h-full">
                            <h2 className="text-3xl font-semibold p-0 m-0">Payment Method</h2>
                            <div className="mt-4 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="inline-flex  items-center justify-center rounded border bg-white text-slate-600 " >
                                        <i className={`${getCardIconClass(billingData?.[0]?.payment_method?.brand)} text-4xl`}></i>
                                    </div>
                                    <div className="text-2xl">
                                        <div className="flex items-center gap-2">
                                            <span>{billingData?.[0]?.payment_method?.brand} •••• {billingData?.[0]?.payment_method?.last4}</span>
                                            {billingData?.[0]?.payment_method?.is_default && (
                                                <span className="rounded border px-2 py-0.5 text-2xl">Default</span>
                                            )}
                                        </div>
                                        <div className="text-muted-foreground">Expires {billingData?.[0]?.payment_method?.exp_month}/{billingData?.[0]?.payment_method?.exp_year}</div>
                                    </div>
                                </div>
                            </div>
                            <a href={billingData?.[0]?.add_payment_method_link}>
                                <button className="mt-4 inline-flex items-center gap-2 text-2xl text-sky-700 hover:underline">
                                    <i className="fa-solid fa-plus"></i>
                                    Add payment method
                                </button>
                            </a>
                        </section>
                    </div>
                    <main className="lg:col-span-12 md:col-span-12 col-span-12 p-6">
                        <div className="space-y-6">
                            <section className="rounded-xl border bg-white p-6 shadow-sm">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-3xl font-semibold m-0">Failed Invoice History</h2>
                                </div>
                                <div className="mt-4 overflow-x-auto">
                                    <div className="min-w-[800px] divide-y text-sm">
                                        <div className="grid grid-cols-7 items-center gap-4 py-3 text-2xl font-bold bg-gray-50 border-b">
                                            <div className="col-span-1">Date</div>
                                            <div className="col-span-1">Module</div>
                                            <div className="col-span-1">Amount</div>
                                            <div className="col-span-1">Status</div>
                                            <div className="col-span-1">Reason</div>
                                            <div className="col-span-1 ">Invoice</div>
                                            <div className="col-span-1 ">Action</div>
                                        </div>
                                        {failedInvoices && failedInvoices.slice(0, failedVisibleContent)?.map((inv) => (
                                            <div key={inv.date} className="grid grid-cols-7 items-center gap-4 py-3 text-2xl">
                                                <div className="col-span-1">{inv?.date?.split(" ")[0]}</div>
                                                <div className="col-span-1">{inv?.module}</div>
                                                <div className="col-span-1">$<span className='text-strong'>{inv?.amount}</span></div>
                                                <div className="col-span-1">
                                                    <span className={`inline-flex items-center gap-1 rounded-full  px-2 py-0.5 text-xl font-semibold ${inv?.status !== 'failed' ? 'text-green-700 bg-green-100' : 'text-rose-600 bg-rose-100'}`}>
                                                        {inv?.status === 'failed' ?
                                                            <i className="fa-solid fa-circle-exclamation"></i>
                                                            : <i className="fa-solid fa-circle-check"></i>}
                                                        {inv?.status}
                                                    </span>
                                                </div>
                                                <div className="col-span-1">
                                                    {inv?.failure_reason?.length > 10 ? (
                                                        <>
                                                            {inv?.failure_reason.slice(0, 10)}...
                                                            <button
                                                                onClick={() => {
                                                                    setSelectedReason(inv?.failure_reason);
                                                                    setShowReasonModal(true);
                                                                }}
                                                                className="ml-2 text-blue-600 underline text-sm"
                                                            >
                                                                View more
                                                            </button>
                                                        </>
                                                    ) : (
                                                        inv?.failure_reason
                                                    )}
                                                </div>
                                                <div className="col-span-1">
                                                    <a
                                                        href={inv?.invoice_pdf}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-block px-3 py-1 text-xl font-medium text-white bg-emerald-600 hover:bg-emerald-700 hover:!text-white rounded-lg shadow"
                                                    >
                                                        Download
                                                    </a>
                                                </div>
                                                {inv?.status !== 'paid' && (
                                                    <div className="col-span-1  text-muted-foreground">
                                                        <a
                                                            href={inv?.hosted_invoice_url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="inline-block px-3 py-1 text-xl font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:!text-white rounded-lg shadow"
                                                        >
                                                            Pay now
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className='flex justify-end'>
                                    {failedInvoices?.length > failedVisibleContent ? (
                                        <button
                                            onClick={handleFailedPagination}
                                            className="mt-4 text-2xl text-sky-700 hover:underline bg-blue-100 text-blue-700 p-2 rounded-lg"
                                        >
                                            View more
                                        </button>
                                    ) : (
                                        failedInvoices?.length > 10 && (
                                            <button
                                                onClick={handleLessfailedPagination}
                                                className="mt-4 text-2xl text-sky-700 hover:underline"
                                            >
                                                View less
                                            </button>
                                        )
                                    )}
                                </div>
                            </section>
                        </div>
                    </main>
                    <main className="lg:col-span-12 md:col-span-12 col-span-12 p-6">
                        <div className="space-y-6">
                            <section className="rounded-xl border bg-white p-6 shadow-sm">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-3xl font-semibold m-0">Paid Invoice History</h2>
                                </div>
                                <div className="mt-4 overflow-x-auto">
                                    <div className="divide-y text-sm">
                                        <div className="grid grid-cols-7 items-center gap-4 py-3 text-2xl font-bold bg-gray-50 border-b">
                                            <div className="col-span-1">Date</div>
                                            <div className="col-span-1">Module</div>
                                            <div className="col-span-1">Amount</div>
                                            <div className="col-span-1">Status</div>
                                            <div className="col-span-1">Reason</div>
                                            <div className="col-span-1 ">Invoice</div>
                                            <div className="col-span-1 ">Action</div>
                                        </div>
                                        {allInvoices && allInvoices.slice(0, visibleCount)?.map((inv) => (
                                            <div key={inv.date} className="grid grid-cols-7 items-center gap-4 py-3 text-2xl">
                                                <div className="col-span-1">{inv.date?.split(" ")[0]}</div>
                                                <div className="col-span-1">{inv?.module}</div>
                                                <div className="col-span-1">$<span className='text-strong'>{inv?.amount}</span></div>
                                                <div className="col-span-1">
                                                    <span className={`inline-flex items-center gap-1 rounded-full  px-2 py-0.5 text-xl font-semibold ${inv?.status !== 'failed' ? 'text-green-700 bg-green-100' : 'text-rose-600 bg-rose-100'}`}>
                                                        {inv?.status === 'failed' ?
                                                            <i className="fa-solid fa-circle-exclamation"></i>
                                                            : <i className="fa-solid fa-circle-check"></i>}
                                                        {inv?.status}
                                                    </span>
                                                </div>
                                                <div className="col-span-1">
                                                    {inv?.failure_reason?.length > 10 ? (
                                                        <>
                                                            {inv.failure_reason.slice(0, 10)}...
                                                            <button
                                                                onClick={() => {
                                                                    setSelectedReason(inv?.failure_reason);
                                                                    setShowReasonModal(true);
                                                                }}
                                                                className="ml-2 text-blue-600 underline text-sm"
                                                            >
                                                                View more
                                                            </button>
                                                        </>
                                                    ) : (
                                                        inv?.failure_reason
                                                    )}
                                                </div>
                                                <div className="col-span-1">
                                                    <a
                                                        href={inv?.invoice_pdf}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-block px-3 py-1 text-xl font-medium text-white bg-emerald-600 hover:bg-emerald-700 hover:!text-white rounded-lg shadow"
                                                    >
                                                        Download
                                                    </a>
                                                </div>
                                                {inv?.status !== 'paid' && (
                                                    <div className="col-span-1 text-end text-muted-foreground">
                                                        <a
                                                            href={inv?.hosted_invoice_url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="inline-block px-3 py-1 text-xl font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:!text-white rounded-lg shadow"
                                                        >
                                                            Pay now
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className='flex justify-end'>
                                    {allInvoices?.length > visibleCount ? (
                                        <button
                                            onClick={handleViewMore}
                                            className="mt-4 text-2xl text-sky-700 hover:underline bg-blue-100 text-blue-700 p-2 rounded-lg"
                                        >
                                            View more
                                        </button>
                                    ) : (
                                        allInvoices?.length > 10 && (
                                            <button
                                                onClick={handleViewLess}
                                                className="mt-4 text-2xl text-sky-700 hover:underline"
                                            >
                                                View less
                                            </button>
                                        )
                                    )}
                                </div>
                            </section>
                        </div>
                    </main>
                </div>
                {(showReasonModal || isOpen) && (
                    showReasonModal ? (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
                                <h2 className="text-2xl font-bold mb-2 mt-1">Failure Reason</h2>
                                <p className="text-gray-700 text-xl">{selectedReason}</p>

                                <div className="mt-6 flex justify-end">
                                    <button
                                        onClick={() => setShowReasonModal(false)}
                                        className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl p-6">
                                <div className="flex justify-between items-center border-b pb-3">
                                    <h2 className="text-2xl font-semibold">Update Billing Info</h2>
                                    <button
                                        onClick={() => setIsOpen(false)}
                                        className="text-gray-500 hover:text-gray-700"
                                    >
                                        ✕
                                    </button>
                                </div>
                                <form onSubmit={handleSubmit} className="mt-4 space-y-4">
                                    <div>
                                        <label className="block text-lg font-medium">Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="w-full !border border-gray-300 rounded-lg px-3 py-2 mt-1"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-lg font-medium">Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full !border border-gray-300 rounded-lg px-3 py-2 mt-1"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-lg font-medium">Phone</label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="w-full !border border-gray-300 rounded-lg px-3 py-2 mt-1"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-lg font-medium">Address</label>
                                        <textarea
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            rows="3"
                                            className="w-full !border border-gray-300 rounded-lg px-3 py-2 mt-1"
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="flex justify-end gap-2 pt-3 border-t">
                                        <button
                                            type="button"
                                            onClick={() => setIsOpen(false)}
                                            className="px-4 py-2 rounded-lg border"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )
                )}
            </div>
        </Master >
    )
}

export default Account
